<style lang="scss" scoped>
.introduction {
	text-align: center;
	padding-top: 40px;
	p {
		padding-bottom: 40px;
	}
	img {
		max-height: 80px;
		max-width: 80px;
	}
}
</style>

<template lang="pug">
layout-modal.introduction
    img(src="https://edu.wonde.com/emoji-assets/128/1f44b.png")
    h1.mt-4 Create a classroom!
    p Creating classrooms allows you to give groups of students access to certain apps.
    template(slot="footer")
        el-button(type="primary", @click="toggleModal") OK, lets go!
</template>

<script>
import CreateClassroomModal from "@/components/classroom/Create";

export default {
	methods: {
		toggleModal() {
			this.$vuedals.open({
				component: CreateClassroomModal,
				size: "lg",
				title: "Create classroom"
			});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/classroom/create/Introduction.vue